// AUTO-GENERATED reference data. Do not edit by hand.
// Countries: ISO 3166-1 (numeric code as value). MCC: ISO 18245.
import { DropdownOption } from "components/searchable-dropdown/types";

export interface Mcc {
  /** ISO 18245 merchant category code, e.g. 5411 for grocery stores. */
  code: number;
  description: string;
}

export const MCC_CODES: Mcc[] = [
  { code: 742, description: "Veterinary Services" },
  { code: 763, description: "Agricultural Co-operatives" },
  { code: 780, description: "Horticultural Services, Landscaping Services" },
  { code: 1520, description: "General Contractors-Residential and Commercial" },
  { code: 1711, description: "Air Conditioning Contractors – Sales and Installation, Heating Contractors – Sales, Service, Installation" },
  { code: 1731, description: "Electrical Contractors" },
  { code: 1740, description: "Insulation – Contractors, Masonry, Stonework Contractors, Plastering Contractors, Stonework and Masonry Contractors, Tile Settings Contractors" },
  { code: 1750, description: "Carpentry Contractors" },
  { code: 1761, description: "Roofing – Contractors, Sheet Metal Work – Contractors, Siding – Contractors" },
  { code: 1771, description: "Contractors – Concrete Work" },
  { code: 1799, description: "Contractors – Special Trade, Not Elsewhere Classified" },
  { code: 2741, description: "Miscellaneous Publishing and Printing" },
  { code: 2791, description: "Typesetting, Plate Making, & Related Services" },
  { code: 2842, description: "Specialty Cleaning, Polishing, and Sanitation Preparations" },
  { code: 3000, description: "UNITED AIRLINES" },
  { code: 3001, description: "AMERICAN AIRLINES" },
  { code: 3002, description: "PAN AMERICAN" },
  { code: 3003, description: "Airlines" },
  { code: 3004, description: "TRANS WORLD AIRLINES" },
  { code: 3005, description: "BRITISH AIRWAYS" },
  { code: 3006, description: "JAPAN AIRLINES" },
  { code: 3007, description: "AIR FRANCE" },
  { code: 3008, description: "LUFTHANSA" },
  { code: 3009, description: "AIR CANADA" },
  { code: 3010, description: "KLM (ROYAL DUTCH AIRLINES)" },
  { code: 3011, description: "AEORFLOT" },
  { code: 3012, description: "QANTAS" },
  { code: 3013, description: "ALITALIA" },
  { code: 3014, description: "SAUDIA ARABIAN AIRLINES" },
  { code: 3015, description: "SWISSAIR" },
  { code: 3016, description: "SAS" },
  { code: 3017, description: "SOUTH AFRICAN AIRWAYS" },
  { code: 3018, description: "VARIG (BRAZIL)" },
  { code: 3019, description: "Airlines" },
  { code: 3020, description: "AIR-INDIA" },
  { code: 3021, description: "AIR ALGERIE" },
  { code: 3022, description: "PHILIPPINE AIRLINES" },
  { code: 3023, description: "MEXICANA" },
  { code: 3024, description: "PAKISTAN INTERNATIONAL" },
  { code: 3025, description: "AIR NEW ZEALAND" },
  { code: 3026, description: "Airlines" },
  { code: 3027, description: "UTA/INTERAIR" },
  { code: 3028, description: "AIR MALTA" },
  { code: 3029, description: "SABENA" },
  { code: 3030, description: "AEROLINEAS ARGENTINAS" },
  { code: 3031, description: "OLYMPIC AIRWAYS" },
  { code: 3032, description: "EL AL" },
  { code: 3033, description: "ANSETT AIRLINES" },
  { code: 3034, description: "AUSTRAINLIAN AIRLINES" },
  { code: 3035, description: "TAP (PORTUGAL)" },
  { code: 3036, description: "VASP (BRAZIL)" },
  { code: 3037, description: "EGYPTAIR" },
  { code: 3038, description: "KUWAIT AIRLINES" },
  { code: 3039, description: "AVIANCA" },
  { code: 3040, description: "GULF AIR (BAHRAIN)" },
  { code: 3041, description: "BALKAN-BULGARIAN AIRLINES" },
  { code: 3042, description: "FINNAIR" },
  { code: 3043, description: "AER LINGUS" },
  { code: 3044, description: "AIR LANKA" },
  { code: 3045, description: "NIGERIA AIRWAYS" },
  { code: 3046, description: "CRUZEIRO DO SUL (BRAZIJ)" },
  { code: 3047, description: "THY (TURKEY)" },
  { code: 3048, description: "ROYAL AIR MAROC" },
  { code: 3049, description: "TUNIS AIR" },
  { code: 3050, description: "ICELANDAIR" },
  { code: 3051, description: "AUSTRIAN AIRLINES" },
  { code: 3052, description: "LANCHILE" },
  { code: 3053, description: "AVIACO (SPAIN)" },
  { code: 3054, description: "LADECO (CHILE)" },
  { code: 3055, description: "LAB (BOLIVIA)" },
  { code: 3056, description: "QUEBECAIRE" },
  { code: 3057, description: "EASTWEST AIRLINES (AUSTRALIA)" },
  { code: 3058, description: "DELTA" },
  { code: 3059, description: "Airlines" },
  { code: 3060, description: "NORTHWEST" },
  { code: 3061, description: "CONTINENTAL" },
  { code: 3062, description: "WESTERN" },
  { code: 3063, description: "US AIR" },
  { code: 3064, description: "Airlines" },
  { code: 3065, description: "AIRINTER" },
  { code: 3066, description: "SOUTHWEST" },
  { code: 3067, description: "Airlines" },
  { code: 3068, description: "Airlines" },
  { code: 3069, description: "SUN COUNTRY AIRLINES" },
  { code: 3070, description: "Airlines" },
  { code: 3071, description: "AIR BRITISH COLUBIA" },
  { code: 3072, description: "Airlines" },
  { code: 3073, description: "Airlines" },
  { code: 3074, description: "Airlines" },
  { code: 3075, description: "SINGAPORE AIRLINES" },
  { code: 3076, description: "AEROMEXICO" },
  { code: 3077, description: "THAI AIRWAYS" },
  { code: 3078, description: "CHINA AIRLINES" },
  { code: 3079, description: "Airlines" },
  { code: 3080, description: "Airlines" },
  { code: 3081, description: "NORDAIR" },
  { code: 3082, description: "KOREAN AIRLINES" },
  { code: 3083, description: "AIR AFRIGUE" },
  { code: 3084, description: "EVA AIRLINES" },
  { code: 3085, description: "MIDWEST EXPRESS AIRLINES, INC." },
  { code: 3086, description: "Airlines" },
  { code: 3087, description: "METRO AIRLINES" },
  { code: 3088, description: "CROATIA AIRLINES" },
  { code: 3089, description: "TRANSAERO" },
  { code: 3090, description: "Airlines" },
  { code: 3091, description: "Airlines" },
  { code: 3092, description: "Airlines" },
  { code: 3093, description: "Airlines" },
  { code: 3094, description: "ZAMBIA AIRWAYS" },
  { code: 3095, description: "Airlines" },
  { code: 3096, description: "AIR ZIMBABWE" },
  { code: 3097, description: "Airlines" },
  { code: 3098, description: "Airlines" },
  { code: 3099, description: "CATHAY PACIFIC" },
  { code: 3100, description: "MALAYSIAN AIRLINE SYSTEM" },
  { code: 3101, description: "Airlines" },
  { code: 3102, description: "IBERIA" },
  { code: 3103, description: "GARUDA (INDONESIA)" },
  { code: 3104, description: "Airlines" },
  { code: 3105, description: "Airlines" },
  { code: 3106, description: "BRAATHENS S.A.F.E. (NORWAY)" },
  { code: 3107, description: "Airlines" },
  { code: 3108, description: "Airlines" },
  { code: 3109, description: "Airlines" },
  { code: 3110, description: "WINGS AIRWAYS" },
  { code: 3111, description: "BRITISH MIDLAND" },
  { code: 3112, description: "WINDWARD ISLAND" },
  { code: 3113, description: "Airlines" },
  { code: 3114, description: "Airlines" },
  { code: 3115, description: "Airlines" },
  { code: 3116, description: "Airlines" },
  { code: 3117, description: "VIASA" },
  { code: 3118, description: "VALLEY AIRLINES" },
  { code: 3119, description: "Airlines" },
  { code: 3120, description: "Airlines" },
  { code: 3121, description: "Airlines" },
  { code: 3122, description: "Airlines" },
  { code: 3123, description: "Airlines" },
  { code: 3124, description: "Airlines" },
  { code: 3125, description: "TAN" },
  { code: 3126, description: "TALAIR" },
  { code: 3127, description: "TACA INTERNATIONAL" },
  { code: 3128, description: "Airlines" },
  { code: 3129, description: "SURINAM AIRWAYS" },
  { code: 3130, description: "SUN WORLD INTERNATIONAL" },
  { code: 3131, description: "Airlines" },
  { code: 3132, description: "Airlines" },
  { code: 3133, description: "SUNBELT AIRLINES" },
  { code: 3134, description: "Airlines" },
  { code: 3135, description: "SUDAN AIRWAYS" },
  { code: 3136, description: "Airlines" },
  { code: 3137, description: "SINGLETON" },
  { code: 3138, description: "SIMMONS AIRLINES" },
  { code: 3139, description: "Airlines" },
  { code: 3140, description: "Airlines" },
  { code: 3141, description: "Airlines" },
  { code: 3142, description: "Airlines" },
  { code: 3143, description: "SCENIC AIRLINES" },
  { code: 3144, description: "VIRGIN ATLANTIC" },
  { code: 3145, description: "SAN JUAN AIRLINES" },
  { code: 3146, description: "LUXAIR" },
  { code: 3147, description: "Airlines" },
  { code: 3148, description: "Airlines" },
  { code: 3149, description: "Airlines" },
  { code: 3150, description: "Airlines" },
  { code: 3151, description: "AIR ZAIRE" },
  { code: 3152, description: "Airlines" },
  { code: 3153, description: "Airlines" },
  { code: 3154, description: "PRINCEVILLE" },
  { code: 3155, description: "Airlines" },
  { code: 3156, description: "Airlines" },
  { code: 3157, description: "Airlines" },
  { code: 3158, description: "Airlines" },
  { code: 3159, description: "PBA" },
  { code: 3160, description: "Airlines" },
  { code: 3161, description: "ALL NIPPON AIRWAYS" },
  { code: 3162, description: "Airlines" },
  { code: 3163, description: "Airlines" },
  { code: 3164, description: "NORONTAIR" },
  { code: 3165, description: "NEW YORK HELICOPTER" },
  { code: 3166, description: "Airlines" },
  { code: 3167, description: "Airlines" },
  { code: 3168, description: "Airlines" },
  { code: 3169, description: "Airlines" },
  { code: 3170, description: "NOUNT COOK" },
  { code: 3171, description: "CANADIAN AIRLINES INTERNATIONAL" },
  { code: 3172, description: "NATIONAIR" },
  { code: 3173, description: "Airlines" },
  { code: 3174, description: "Airlines" },
  { code: 3175, description: "Airlines" },
  { code: 3176, description: "METROFLIGHT AIRLINES" },
  { code: 3177, description: "Airlines" },
  { code: 3178, description: "MESA AIR" },
  { code: 3179, description: "Airlines" },
  { code: 3180, description: "Airlines" },
  { code: 3181, description: "MALEV" },
  { code: 3182, description: "LOT (POLAND)" },
  { code: 3183, description: "Airlines" },
  { code: 3184, description: "LIAT" },
  { code: 3185, description: "LAV (VENEZUELA)" },
  { code: 3186, description: "LAP (PARAGUAY)" },
  { code: 3187, description: "LACSA (COSTA RICA)" },
  { code: 3188, description: "Airlines" },
  { code: 3189, description: "Airlines" },
  { code: 3190, description: "JUGOSLAV AIR" },
  { code: 3191, description: "ISLAND AIRLINES" },
  { code: 3192, description: "IRAN AIR" },
  { code: 3193, description: "INDIAN AIRLINES" },
  { code: 3194, description: "Airlines" },
  { code: 3195, description: "Airlines" },
  { code: 3196, description: "HAWAIIAN AIR" },
  { code: 3197, description: "HAVASU AIRLINES" },
  { code: 3198, description: "Airlines" },
  { code: 3199, description: "Airlines" },
  { code: 3200, description: "FUYANA AIRWAYS" },
  { code: 3201, description: "Airlines" },
  { code: 3202, description: "Airlines" },
  { code: 3203, description: "GOLDEN PACIFIC AIR" },
  { code: 3204, description: "FREEDOM AIR" },
  { code: 3205, description: "Airlines" },
  { code: 3206, description: "Airlines" },
  { code: 3207, description: "Airlines" },
  { code: 3208, description: "Airlines" },
  { code: 3209, description: "Airlines" },
  { code: 3210, description: "Airlines" },
  { code: 3211, description: "Airlines" },
  { code: 3212, description: "DOMINICANA" },
  { code: 3213, description: "Airlines" },
  { code: 3214, description: "Airlines" },
  { code: 3215, description: "DAN AIR SERVICES" },
  { code: 3216, description: "CUMBERLAND AIRLINES" },
  { code: 3217, description: "CSA" },
  { code: 3218, description: "CROWN AIR" },
  { code: 3219, description: "COPA" },
  { code: 3220, description: "COMPANIA FAUCETT" },
  { code: 3221, description: "TRANSPORTES AEROS MILITARES ECCUATORANOS" },
  { code: 3222, description: "COMMAND AIRWAYS" },
  { code: 3223, description: "COMAIR" },
  { code: 3224, description: "Airlines" },
  { code: 3225, description: "Airlines" },
  { code: 3226, description: "Airlines" },
  { code: 3227, description: "Airlines" },
  { code: 3228, description: "CAYMAN AIRWAYS" },
  { code: 3229, description: "SAETA SOCIAEDAD ECUATORIANOS DE TRANSPORTES AEREOS" },
  { code: 3230, description: "Airlines" },
  { code: 3231, description: "SASHA SERVICIO AERO DE HONDURAS" },
  { code: 3232, description: "Airlines" },
  { code: 3233, description: "CAPITOL AIR" },
  { code: 3234, description: "BWIA" },
  { code: 3235, description: "BROKWAY AIR" },
  { code: 3236, description: "Airlines" },
  { code: 3237, description: "Airlines" },
  { code: 3238, description: "BEMIDJI AIRLINES" },
  { code: 3239, description: "BAR HARBOR AIRLINES" },
  { code: 3240, description: "BAHAMASAIR" },
  { code: 3241, description: "AVIATECA (GUATEMALA)" },
  { code: 3242, description: "AVENSA" },
  { code: 3243, description: "AUSTRIAN AIR SERVICE" },
  { code: 3244, description: "Airlines" },
  { code: 3245, description: "Airlines" },
  { code: 3246, description: "Airlines" },
  { code: 3247, description: "Airlines" },
  { code: 3248, description: "Airlines" },
  { code: 3249, description: "Airlines" },
  { code: 3250, description: "Airlines" },
  { code: 3251, description: "ALOHA AIRLINES" },
  { code: 3252, description: "ALM" },
  { code: 3253, description: "AMERICA WEST" },
  { code: 3254, description: "TRUMP AIRLINE" },
  { code: 3255, description: "Airlines" },
  { code: 3256, description: "ALASKA AIRLINES" },
  { code: 3257, description: "Airlines" },
  { code: 3258, description: "Airlines" },
  { code: 3259, description: "AMERICAN TRANS AIR" },
  { code: 3260, description: "Airlines" },
  { code: 3261, description: "AIR CHINA" },
  { code: 3262, description: "RENO AIR, INC." },
  { code: 3263, description: "Airlines" },
  { code: 3264, description: "Airlines" },
  { code: 3265, description: "Airlines" },
  { code: 3266, description: "AIR SEYCHELLES" },
  { code: 3267, description: "AIR PANAMA" },
  { code: 3268, description: "Airlines" },
  { code: 3269, description: "Airlines" },
  { code: 3270, description: "Airlines" },
  { code: 3271, description: "Airlines" },
  { code: 3272, description: "Airlines" },
  { code: 3273, description: "Airlines" },
  { code: 3274, description: "Airlines" },
  { code: 3275, description: "Airlines" },
  { code: 3276, description: "Airlines" },
  { code: 3277, description: "Airlines" },
  { code: 3278, description: "Airlines" },
  { code: 3279, description: "Airlines" },
  { code: 3280, description: "AIR JAMAICA" },
  { code: 3281, description: "Airlines" },
  { code: 3282, description: "AIR DJIBOUTI" },
  { code: 3283, description: "Airlines" },
  { code: 3284, description: "AERO VIRGIN ISLANDS" },
  { code: 3285, description: "AERO PERU" },
  { code: 3286, description: "AEROLINEAS NICARAGUENSIS" },
  { code: 3287, description: "AERO COACH AVAIATION" },
  { code: 3288, description: "Airlines" },
  { code: 3289, description: "Airlines" },
  { code: 3290, description: "Airlines" },
  { code: 3291, description: "ARIANA AFGHAN" },
  { code: 3292, description: "CYPRUS AIRWAYS" },
  { code: 3293, description: "ECUATORIANA" },
  { code: 3294, description: "ETHIOPIAN AIRLINES" },
  { code: 3295, description: "KENYA AIRLINES" },
  { code: 3296, description: "Airlines" },
  { code: 3297, description: "Airlines" },
  { code: 3298, description: "AIR MAURITIUS" },
  { code: 3299, description: "WIDERO’S FLYVESELSKAP" },
  { code: 3351, description: "AFFILIATED AUTO RENTAL" },
  { code: 3352, description: "AMERICAN INTL RENT-A-CAR" },
  { code: 3353, description: "BROOKS RENT-A-CAR" },
  { code: 3354, description: "ACTION AUTO RENTAL" },
  { code: 3355, description: "Car Rental" },
  { code: 3356, description: "Car Rental" },
  { code: 3357, description: "HERTZ RENT-A-CAR" },
  { code: 3358, description: "Car Rental" },
  { code: 3359, description: "PAYLESS CAR RENTAL" },
  { code: 3360, description: "SNAPPY CAR RENTAL" },
  { code: 3361, description: "AIRWAYS RENT-A-CAR" },
  { code: 3362, description: "ALTRA AUTO RENTAL" },
  { code: 3363, description: "Car Rental" },
  { code: 3364, description: "AGENCY RENT-A-CAR" },
  { code: 3365, description: "Car Rental" },
  { code: 3366, description: "BUDGET RENT-A-CAR" },
  { code: 3367, description: "Car Rental" },
  { code: 3368, description: "HOLIDAY RENT-A-WRECK" },
  { code: 3369, description: "Car Rental" },
  { code: 3370, description: "RENT-A-WRECK" },
  { code: 3371, description: "Car Rental" },
  { code: 3372, description: "Car Rental" },
  { code: 3373, description: "Car Rental" },
  { code: 3374, description: "Car Rental" },
  { code: 3375, description: "Car Rental" },
  { code: 3376, description: "AJAX RENT-A-CAR" },
  { code: 3377, description: "Car Rental" },
  { code: 3378, description: "Car Rental" },
  { code: 3379, description: "Car Rental" },
  { code: 3380, description: "Car Rental" },
  { code: 3381, description: "EUROP CAR" },
  { code: 3382, description: "Car Rental" },
  { code: 3383, description: "Car Rental" },
  { code: 3384, description: "Car Rental" },
  { code: 3385, description: "TROPICAL RENT-A-CAR" },
  { code: 3386, description: "SHOWCASE RENTAL CARS" },
  { code: 3387, description: "ALAMO RENT-A-CAR" },
  { code: 3388, description: "Car Rental" },
  { code: 3389, description: "AVIS RENT-A-CAR" },
  { code: 3390, description: "DOLLAR RENT-A-CAR" },
  { code: 3391, description: "EUROPE BY CAR" },
  { code: 3392, description: "Car Rental" },
  { code: 3393, description: "NATIONAL CAR RENTAL" },
  { code: 3394, description: "KEMWELL GROUP RENT-A-CAR" },
  { code: 3395, description: "THRIFTY RENT-A-CAR" },
  { code: 3396, description: "TILDEN TENT-A-CAR" },
  { code: 3397, description: "Car Rental" },
  { code: 3398, description: "ECONO-CAR RENT-A-CAR" },
  { code: 3399, description: "Car Rental" },
  { code: 3400, description: "AUTO HOST COST CAR RENTALS" },
  { code: 3401, description: "Car Rental" },
  { code: 3402, description: "Car Rental" },
  { code: 3403, description: "Car Rental" },
  { code: 3404, description: "Car Rental" },
  { code: 3405, description: "ENTERPRISE RENT-A-CAR" },
  { code: 3406, description: "Car Rental" },
  { code: 3407, description: "Car Rental" },
  { code: 3408, description: "Car Rental" },
  { code: 3409, description: "GENERAL RENT-A-CAR" },
  { code: 3410, description: "Car Rental" },
  { code: 3411, description: "Car Rental" },
  { code: 3412, description: "A-1 RENT-A-CAR" },
  { code: 3413, description: "Car Rental" },
  { code: 3414, description: "GODFREY NATL RENT-A-CAR" },
  { code: 3415, description: "Car Rental" },
  { code: 3416, description: "Car Rental" },
  { code: 3417, description: "Car Rental" },
  { code: 3418, description: "Car Rental" },
  { code: 3419, description: "ALPHA RENT-A-CAR" },
  { code: 3420, description: "ANSA INTL RENT-A-CAR" },
  { code: 3421, description: "ALLSTAE RENT-A-CAR" },
  { code: 3422, description: "Car Rental" },
  { code: 3423, description: "AVCAR RENT-A-CAR" },
  { code: 3424, description: "Car Rental" },
  { code: 3425, description: "AUTOMATE RENT-A-CAR" },
  { code: 3426, description: "Car Rental" },
  { code: 3427, description: "AVON RENT-A-CAR" },
  { code: 3428, description: "CAREY RENT-A-CAR" },
  { code: 3429, description: "INSURANCE RENT-A-CAR" },
  { code: 3430, description: "MAJOR RENT-A-CAR" },
  { code: 3431, description: "REPLACEMENT RENT-A-CAR" },
  { code: 3432, description: "RESERVE RENT-A-CAR" },
  { code: 3433, description: "UGLY DUCKLING RENT-A-CAR" },
  { code: 3434, description: "USA RENT-A-CAR" },
  { code: 3435, description: "VALUE RENT-A-CAR" },
  { code: 3436, description: "AUTOHANSA RENT-A-CAR" },
  { code: 3437, description: "CITE RENT-A-CAR" },
  { code: 3438, description: "INTERENT RENT-A-CAR" },
  { code: 3439, description: "MILLEVILLE RENT-A-CAR" },
  { code: 3440, description: "VIA ROUTE RENT-A-CAR" },
  { code: 3441, description: "Car Rental" },
  { code: 3501, description: "HOLIDAY INNS, HOLIDAY INN EXPRESS" },
  { code: 3502, description: "BEST WESTERN HOTELS" },
  { code: 3503, description: "SHERATON HOTELS" },
  { code: 3504, description: "HILTON HOTELS" },
  { code: 3505, description: "FORTE HOTELS" },
  { code: 3506, description: "GOLDEN TULIP HOTELS" },
  { code: 3507, description: "FRIENDSHIP INNS" },
  { code: 3508, description: "QUALITY INNS, QUALITY SUITES" },
  { code: 3509, description: "MARRIOTT HOTELS" },
  { code: 3510, description: "DAYS INN, DAYSTOP" },
  { code: 3511, description: "ARABELLA HOTELS" },
  { code: 3512, description: "INTER-CONTINENTAL HOTELS" },
  { code: 3513, description: "WESTIN HOTELS" },
  { code: 3514, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3515, description: "RODEWAY INNS" },
  { code: 3516, description: "LA QUINTA MOTOR INNS" },
  { code: 3517, description: "AMERICANA HOTELS" },
  { code: 3518, description: "SOL HOTELS" },
  { code: 3519, description: "PULLMAN INTERNATIONAL HOTELS" },
  { code: 3520, description: "MERIDIEN HOTELS" },
  { code: 3521, description: "CREST HOTELS (see FORTE HOTELS)" },
  { code: 3522, description: "TOKYO HOTEL" },
  { code: 3523, description: "PENNSULA HOTEL" },
  { code: 3524, description: "WELCOMGROUP HOTELS" },
  { code: 3525, description: "DUNFEY HOTELS" },
  { code: 3526, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3527, description: "DOWNTOWNER-PASSPORT HOTEL" },
  { code: 3528, description: "RED LION HOTELS, RED LION INNS" },
  { code: 3529, description: "CP HOTELS" },
  { code: 3530, description: "RENAISSANCE HOTELS, STOUFFER HOTELS" },
  { code: 3531, description: "ASTIR HOTELS" },
  { code: 3532, description: "SUN ROUTE HOTELS" },
  { code: 3533, description: "HOTEL IBIS" },
  { code: 3534, description: "SOUTHERN PACIFIC HOTELS" },
  { code: 3535, description: "HILTON INTERNATIONAL" },
  { code: 3536, description: "AMFAC HOTELS" },
  { code: 3537, description: "ANA HOTEL" },
  { code: 3538, description: "CONCORDE HOTELS" },
  { code: 3539, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3540, description: "IBEROTEL HOTELS" },
  { code: 3541, description: "HOTEL OKURA" },
  { code: 3542, description: "ROYAL HOTELS" },
  { code: 3543, description: "FOUR SEASONS HOTELS" },
  { code: 3544, description: "CIGA HOTELS" },
  { code: 3545, description: "SHANGRI-LA INTERNATIONAL" },
  { code: 3546, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3547, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3548, description: "HOTELES MELIA" },
  { code: 3549, description: "AUBERGE DES GOVERNEURS" },
  { code: 3550, description: "REGAL 8 INNS" },
  { code: 3551, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3552, description: "COAST HOTELS" },
  { code: 3553, description: "PARK INNS INTERNATIONAL" },
  { code: 3554, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3555, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3556, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3557, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3558, description: "JOLLY HOTELS" },
  { code: 3559, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3560, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3561, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3562, description: "COMFORT INNS" },
  { code: 3563, description: "JOURNEY’S END MOTLS" },
  { code: 3564, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3565, description: "RELAX INNS" },
  { code: 3566, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3567, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3568, description: "LADBROKE HOTELS" },
  { code: 3569, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3570, description: "FORUM HOTELS" },
  { code: 3571, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3572, description: "MIYAKO HOTELS" },
  { code: 3573, description: "SANDMAN HOTELS" },
  { code: 3574, description: "VENTURE INNS" },
  { code: 3575, description: "VAGABOND HOTELS" },
  { code: 3576, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3577, description: "MANDARIN ORIENTAL HOTEL" },
  { code: 3578, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3579, description: "HOTEL MERCURE" },
  { code: 3580, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3581, description: "DELTA HOTEL" },
  { code: 3582, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3583, description: "SAS HOTELS" },
  { code: 3584, description: "PRINCESS HOTELS INTERNATIONAL" },
  { code: 3585, description: "HUNGAR HOTELS" },
  { code: 3586, description: "SOKOS HOTELS" },
  { code: 3587, description: "DORAL HOTELS" },
  { code: 3588, description: "HELMSLEY HOTELS" },
  { code: 3589, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3590, description: "FAIRMONT HOTELS" },
  { code: 3591, description: "SONESTA HOTELS" },
  { code: 3592, description: "OMNI HOTELS" },
  { code: 3593, description: "CUNARD HOTELS" },
  { code: 3594, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3595, description: "HOSPITALITY INTERNATIONAL" },
  { code: 3596, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3597, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3598, description: "REGENT INTERNATIONAL HOTELS" },
  { code: 3599, description: "PANNONIA HOTELS" },
  { code: 3600, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3601, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3602, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3603, description: "NOAH’S HOTELS" },
  { code: 3604, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3605, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3606, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3607, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3608, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3609, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3610, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3611, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3612, description: "MOVENPICK HOTELS" },
  { code: 3613, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3614, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3615, description: "TRAVELODGE" },
  { code: 3616, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3617, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3618, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3619, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3620, description: "TELFORD INTERNATIONAL" },
  { code: 3621, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3622, description: "MERLIN HOTELS" },
  { code: 3623, description: "DORINT HOTELS" },
  { code: 3624, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3625, description: "HOTLE UNIVERSALE" },
  { code: 3626, description: "PRINCE HOTELS" },
  { code: 3627, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3628, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3629, description: "DAN HOTELS" },
  { code: 3630, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3631, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3632, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3633, description: "RANK HOTELS" },
  { code: 3634, description: "SWISSOTEL" },
  { code: 3635, description: "RESO HOTELS" },
  { code: 3636, description: "SAROVA HOTELS" },
  { code: 3637, description: "RAMADA INNS, RAMADA LIMITED" },
  { code: 3638, description: "HO JO INN, HOWARD JOHNSON" },
  { code: 3639, description: "MOUNT CHARLOTTE THISTLE" },
  { code: 3640, description: "HYATT HOTEL" },
  { code: 3641, description: "SOFITEL HOTELS" },
  { code: 3642, description: "NOVOTEL HOTELS" },
  { code: 3643, description: "STEIGENBERGER HOTELS" },
  { code: 3644, description: "ECONO LODGES" },
  { code: 3645, description: "QUEENS MOAT HOUSES" },
  { code: 3646, description: "SWALLOW HOTELS" },
  { code: 3647, description: "HUSA HOTELS" },
  { code: 3648, description: "DE VERE HOTELS" },
  { code: 3649, description: "RADISSON HOTELS" },
  { code: 3650, description: "RED ROOK INNS" },
  { code: 3651, description: "IMPERIAL LONDON HOTEL" },
  { code: 3652, description: "EMBASSY HOTELS" },
  { code: 3653, description: "PENTA HOTELS" },
  { code: 3654, description: "LOEWS HOTELS" },
  { code: 3655, description: "SCANDIC HOTELS" },
  { code: 3656, description: "SARA HOTELS" },
  { code: 3657, description: "OBEROI HOTELS" },
  { code: 3658, description: "OTANI HOTELS" },
  { code: 3659, description: "TAJ HOTELS INTERNATIONAL" },
  { code: 3660, description: "KNIGHTS INNS" },
  { code: 3661, description: "METROPOLE HOTELS" },
  { code: 3662, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3663, description: "HOTELES EL PRESIDENTS" },
  { code: 3664, description: "FLAG INN" },
  { code: 3665, description: "HAMPTON INNS" },
  { code: 3666, description: "STAKIS HOTELS" },
  { code: 3667, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3668, description: "MARITIM HOTELS" },
  { code: 3669, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3670, description: "ARCARD HOTELS" },
  { code: 3671, description: "ARCTIA HOTELS" },
  { code: 3672, description: "CAMPANIEL HOTELS" },
  { code: 3673, description: "IBUSZ HOTELS" },
  { code: 3674, description: "RANTASIPI HOTELS" },
  { code: 3675, description: "INTERHOTEL CEDOK" },
  { code: 3676, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3677, description: "CLIMAT DE FRANCE HOTELS" },
  { code: 3678, description: "CUMULUS HOTELS" },
  { code: 3679, description: "DANUBIUS HOTEL" },
  { code: 3680, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3681, description: "ADAMS MARK HOTELS" },
  { code: 3682, description: "ALLSTAR INNS" },
  { code: 3683, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3684, description: "BUDGET HOST INNS" },
  { code: 3685, description: "BUDGETEL HOTELS" },
  { code: 3686, description: "SUISSE CHALETS" },
  { code: 3687, description: "CLARION HOTELS" },
  { code: 3688, description: "COMPRI HOTELS" },
  { code: 3689, description: "CONSORT HOTELS" },
  { code: 3690, description: "COURTYARD BY MARRIOTT" },
  { code: 3691, description: "DILLION INNS" },
  { code: 3692, description: "DOUBLETREE HOTELS" },
  { code: 3693, description: "DRURY INNS" },
  { code: 3694, description: "ECONOMY INNS OF AMERICA" },
  { code: 3695, description: "EMBASSY SUITES" },
  { code: 3696, description: "EXEL INNS" },
  { code: 3697, description: "FARFIELD HOTELS" },
  { code: 3698, description: "HARLEY HOTELS" },
  { code: 3699, description: "MIDWAY MOTOR LODGE" },
  { code: 3700, description: "MOTEL 6" },
  { code: 3701, description: "GUEST QUARTERS (Formally PICKETT SUITE HOTELS)" },
  { code: 3702, description: "THE REGISTRY HOTELS" },
  { code: 3703, description: "RESIDENCE INNS" },
  { code: 3704, description: "ROYCE HOTELS" },
  { code: 3705, description: "SANDMAN INNS" },
  { code: 3706, description: "SHILO INNS" },
  { code: 3707, description: "SHONEY’S INNS" },
  { code: 3708, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3709, description: "SUPER8 MOTELS" },
  { code: 3710, description: "THE RITZ CARLTON HOTELS" },
  { code: 3711, description: "FLAG INNS (AUSRALIA)" },
  { code: 3712, description: "GOLDEN CHAIN HOTEL" },
  { code: 3713, description: "QUALITY PACIFIC HOTEL" },
  { code: 3714, description: "FOUR SEASONS HOTEL (AUSTRALIA)" },
  { code: 3715, description: "FARIFIELD INN" },
  { code: 3716, description: "CARLTON HOTELS" },
  { code: 3717, description: "CITY LODGE HOTELS" },
  { code: 3718, description: "KAROS HOTELS" },
  { code: 3719, description: "PROTEA HOTELS" },
  { code: 3720, description: "SOUTHERN SUN HOTELS" },
  { code: 3721, description: "HILTON CONRAD" },
  { code: 3722, description: "WYNDHAM HOTEL AND RESORTS" },
  { code: 3723, description: "RICA HOTELS" },
  { code: 3724, description: "INER NOR HOTELS" },
  { code: 3725, description: "SEAINES PLANATION" },
  { code: 3726, description: "RIO SUITES" },
  { code: 3727, description: "BROADMOOR HOTEL" },
  { code: 3728, description: "BALLY’S HOTEL AND CASINO" },
  { code: 3729, description: "JOHN ASCUAGA’S NUGGET" },
  { code: 3730, description: "MGM GRAND HOTEL" },
  { code: 3731, description: "HARRAH’S HOTELS AND CASINOS" },
  { code: 3732, description: "OPRYLAND HOTEL" },
  { code: 3733, description: "BOCA RATON RESORT" },
  { code: 3734, description: "HARVEY/BRISTOL HOTELS" },
  { code: 3735, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3736, description: "COLORADO BELLE/EDGEWATER RESORT" },
  { code: 3737, description: "RIVIERA HOTEL AND CASINO" },
  { code: 3738, description: "TROPICANA RESORT AND CASINO" },
  { code: 3739, description: "WOODSIDE HOTELS AND RESORTS" },
  { code: 3740, description: "TOWNPLACE SUITES" },
  { code: 3741, description: "MILLENIUM BROADWAY HOTEL" },
  { code: 3742, description: "CLUB MED" },
  { code: 3743, description: "BILTMORE HOTEL AND SUITES" },
  { code: 3744, description: "CAREFREE RESORTS" },
  { code: 3745, description: "ST. REGIS HOTEL" },
  { code: 3746, description: "THE ELIOT HOTEL" },
  { code: 3747, description: "CLUBCORP/CLUB RESORTS" },
  { code: 3748, description: "WELESLEY INNS" },
  { code: 3749, description: "THE BEVERLY HILLS HOTEL" },
  { code: 3750, description: "CROWNE PLAZA HOTELS" },
  { code: 3751, description: "HOMEWOOD SUITES" },
  { code: 3752, description: "PEABODY HOTELS" },
  { code: 3753, description: "GREENBRIAH RESORTS" },
  { code: 3754, description: "AMELIA ISLAND PLANATION" },
  { code: 3755, description: "THE HOMESTEAD" },
  { code: 3756, description: "SOUTH SEAS RESORTS" },
  { code: 3757, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3758, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3759, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3760, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3761, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3762, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3763, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3764, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3765, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3766, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3767, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3768, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3769, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3770, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3771, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3772, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3773, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3774, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3775, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3776, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3777, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3778, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3779, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3780, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3781, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3782, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3783, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3784, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3785, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3786, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3787, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3788, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3789, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3790, description: "Hotels/Motels/Inns/Resorts" },
  { code: 3816, description: "Home2Suites" },
  { code: 3835, description: "* MASTERS ECONOMY INNS" },
  { code: 4011, description: "Railroads" },
  { code: 4111, description: "Local/Suburban Commuter Passenger Transportation – Railroads, Feries, Local Water Transportation." },
  { code: 4112, description: "Passenger Railways" },
  { code: 4119, description: "Ambulance Services" },
  { code: 4121, description: "Taxicabs and Limousines" },
  { code: 4131, description: "Bus Lines, Including Charters, Tour Buses" },
  { code: 4214, description: "Motor Freight Carriers, Moving and Storage Companies, Trucking – Local/Long Distance, Delivery Services – Local" },
  { code: 4215, description: "Courier Services – Air or Ground, Freight forwarders" },
  { code: 4225, description: "Public warehousing, Storage" },
  { code: 4411, description: "Cruise and Steamship Lines" },
  { code: 4457, description: "Boat Rentals and Leases" },
  { code: 4468, description: "Marinas, Marine Service, and Supplies" },
  { code: 4511, description: "Airlines, Air Carriers ( not listed elsewhere)" },
  { code: 4582, description: "Airports, Airport Terminals, Flying Fields" },
  { code: 4722, description: "Travel Agencies and Tour Operations" },
  { code: 4723, description: "Package Tour Operators (For use in Germany only)" },
  { code: 4784, description: "Toll and Bridge Fees" },
  { code: 4789, description: "Transportation Services, Not elsewhere classified)" },
  { code: 4812, description: "Telecommunications Equipment including telephone sales" },
  { code: 4814, description: "Fax services, Telecommunication Services" },
  { code: 4815, description: "VisaPhone" },
  { code: 4816, description: "Computer Network Services" },
  { code: 4821, description: "Telegraph services" },
  { code: 4829, description: "Money Orders – Wire Transfer" },
  { code: 4899, description: "Cable and other pay television (previously Cable Services)" },
  { code: 4900, description: "Electric, Gas, Sanitary and Water Utilities" },
  { code: 5013, description: "Motor vehicle supplies and new parts" },
  { code: 5021, description: "Office and Commercial Furniture" },
  { code: 5039, description: "Construction Materials, Not Elsewhere Classified" },
  { code: 5044, description: "Office, Photographic, Photocopy, and Microfilm Equipment" },
  { code: 5045, description: "Computers, Computer Peripheral Equipment, Software" },
  { code: 5046, description: "Commercial Equipment, Not Elsewhere Classified" },
  { code: 5047, description: "Medical, Dental Ophthalmic, Hospital Equipment and Supplies" },
  { code: 5051, description: "Metal Service Centers and Offices" },
  { code: 5065, description: "Electrical Parts and Equipment" },
  { code: 5072, description: "Hardware Equipment and Supplies" },
  { code: 5074, description: "Plumbing and Heating Equipment and Supplies" },
  { code: 5085, description: "Industrial Supplies, Not Elsewhere Classified" },
  { code: 5094, description: "Precious Stones and Metals, Watches and Jewelry" },
  { code: 5099, description: "Durable Goods, Not Elsewhere Classified" },
  { code: 5111, description: "Stationery, Office Supplies, Printing, and Writing Paper" },
  { code: 5122, description: "Drugs, Drug Proprietors, and Druggist’s Sundries" },
  { code: 5131, description: "Piece Goods, Notions, and Other Dry Goods" },
  { code: 5137, description: "Men’s Women’s and Children’s Uniforms and Commercial Clothing" },
  { code: 5139, description: "Commercial Footwear" },
  { code: 5169, description: "Chemicals and Allied Products, Not Elsewhere Classified" },
  { code: 5172, description: "Petroleum and Petroleum Products" },
  { code: 5192, description: "Books, Periodicals, and Newspapers" },
  { code: 5193, description: "Florists’ Supplies, Nursery Stock and Flowers" },
  { code: 5198, description: "Paints, Varnishes, and Supplies" },
  { code: 5199, description: "Non-durable Goods, Not Elsewhere Classified" },
  { code: 5200, description: "Home Supply Warehouse Stores" },
  { code: 5211, description: "Lumber and Building Materials Stores" },
  { code: 5231, description: "Glass, Paint, and Wallpaper Stores" },
  { code: 5251, description: "Hardware Stores" },
  { code: 5261, description: "Nurseries – Lawn and Garden Supply Store" },
  { code: 5271, description: "Mobile Home Dealers" },
  { code: 5300, description: "Wholesale Clubs" },
  { code: 5309, description: "Duty Free Store" },
  { code: 5310, description: "Discount Stores" },
  { code: 5311, description: "Department Stores" },
  { code: 5331, description: "Variety Stores" },
  { code: 5399, description: "Misc. General Merchandise" },
  { code: 5411, description: "Grocery Stores, Supermarkets" },
  { code: 5422, description: "Meat Provisioners – Freezer and Locker" },
  { code: 5441, description: "Candy, Nut, and Confectionery Stores" },
  { code: 5451, description: "Dairy Products Stores" },
  { code: 5462, description: "Bakeries" },
  { code: 5499, description: "Misc. Food Stores – Convenience Stores and Specialty Markets" },
  { code: 5511, description: "Car and Truck Dealers (New and Used) Sales, Service, Repairs, Parts, and Leasing" },
  { code: 5521, description: "Automobile and Truck Dealers (Used Only)" },
  { code: 5531, description: "Automobile Supply Stores" },
  { code: 5532, description: "Automotive Tire Stores" },
  { code: 5533, description: "Automotive Parts, Accessories Stores" },
  { code: 5541, description: "Service Stations ( with or without ancillary services)" },
  { code: 5542, description: "Automated Fuel Dispensers" },
  { code: 5551, description: "Boat Dealers" },
  { code: 5561, description: "Recreational and Utility Trailers, Camp Dealers" },
  { code: 5571, description: "Motorcycle Dealers" },
  { code: 5592, description: "Motor Home Dealers" },
  { code: 5598, description: "Snowmobile Dealers" },
  { code: 5599, description: "Miscellaneous Auto Dealers" },
  { code: 5611, description: "Men’s and Boy’s Clothing and Accessories Stores" },
  { code: 5621, description: "Women’s Ready-to-Wear Stores" },
  { code: 5631, description: "Women’s Accessory and Specialty Shops" },
  { code: 5641, description: "Children’s and Infant’s Wear Stores" },
  { code: 5651, description: "Family Clothing Stores" },
  { code: 5655, description: "Sports Apparel, Riding Apparel Stores" },
  { code: 5661, description: "Shoe Stores" },
  { code: 5681, description: "Furriers and Fur Shops" },
  { code: 5691, description: "Men’s and Women’s Clothing Stores" },
  { code: 5697, description: "Tailors, Seamstress, Mending, and Alterations" },
  { code: 5698, description: "Wig and Toupee Stores" },
  { code: 5699, description: "Miscellaneous Apparel and Accessory Shops" },
  { code: 5712, description: "Furniture, Home Furnishings, and Equipment Stores, ExceptAppliances" },
  { code: 5713, description: "Floor Covering Stores" },
  { code: 5714, description: "Drapery, Window Covering and Upholstery Stores" },
  { code: 5718, description: "Fireplace, Fireplace Screens, and Accessories Stores" },
  { code: 5719, description: "Miscellaneous Home Furnishing Specialty Stores" },
  { code: 5722, description: "Household Appliance Stores" },
  { code: 5732, description: "Electronic Sales" },
  { code: 5733, description: "Music Stores, Musical Instruments, Piano Sheet Music" },
  { code: 5734, description: "Computer Software Stores" },
  { code: 5735, description: "Record Shops" },
  { code: 5811, description: "Caterers" },
  { code: 5812, description: "Eating places and Restaurants" },
  { code: 5813, description: "Drinking Places (Alcoholic Beverages), Bars, Taverns, Cocktail lounges, Nightclubs and Discotheques" },
  { code: 5814, description: "Fast Food Restaurants" },
  { code: 5815, description: "Digital Goods: Media, Books, Movies, Music" },
  { code: 5816, description: "Digital Goods: Games" },
  { code: 5817, description: "Digital Goods: Applications (Excludes Games)" },
  { code: 5818, description: "Digital Goods: Large Digital Goods Merchant" },
  { code: 5832, description: "Antique Shops – Sales, Repairs, and Restoration Services" },
  { code: 5912, description: "Drug Stores and Pharmacies" },
  { code: 5921, description: "Package Stores – Beer, Wine, and Liquor" },
  { code: 5931, description: "Used Merchandise and Secondhand Stores" },
  { code: 5932, description: "Antique Shops" },
  { code: 5933, description: "Pawn Shops and Salvage Yards" },
  { code: 5935, description: "Wrecking and Salvage Yards" },
  { code: 5937, description: "Antique Reproductions" },
  { code: 5940, description: "Bicycle Shops – Sales and Service" },
  { code: 5941, description: "Sporting Goods Stores" },
  { code: 5942, description: "Book Stores" },
  { code: 5943, description: "Stationery Stores, Office and School Supply Stores" },
  { code: 5944, description: "Watch, Clock, Jewelry, and Silverware Stores" },
  { code: 5945, description: "Hobby, Toy, and Game Shops" },
  { code: 5946, description: "Camera and Photographic Supply Stores" },
  { code: 5947, description: "Card Shops, Gift, Novelty, and Souvenir Shops" },
  { code: 5948, description: "Leather Goods Stores" },
  { code: 5949, description: "Sewing, Needle, Fabric, and Price Goods Stores" },
  { code: 5950, description: "Glassware/Crystal Stores" },
  { code: 5960, description: "Direct Marketing- Insurance Service" },
  { code: 5961, description: "Mail Order Houses Including Catalog Order Stores, Book/Record Clubs (No longer permitted for U.S. original presentments)" },
  { code: 5962, description: "Direct Marketing – Travel Related Arrangements Services" },
  { code: 5963, description: "Door-to-Door Sales" },
  { code: 5964, description: "Direct Marketing – Catalog Merchant" },
  { code: 5965, description: "Direct Marketing – Catalog and Catalog and Retail Merchant" },
  { code: 5966, description: "Direct Marketing- Outbound Telemarketing Merchant" },
  { code: 5967, description: "Direct Marketing – Inbound Teleservices Merchant" },
  { code: 5968, description: "Direct Marketing – Continuity/Subscription Merchant" },
  { code: 5969, description: "Direct Marketing – Not Elsewhere Classified" },
  { code: 5970, description: "Artist’s Supply and Craft Shops" },
  { code: 5971, description: "Art Dealers and Galleries" },
  { code: 5972, description: "Stamp and Coin Stores – Philatelic and Numismatic Supplies" },
  { code: 5973, description: "Religious Goods Stores" },
  { code: 5975, description: "Hearing Aids – Sales, Service, and Supply Stores" },
  { code: 5976, description: "Orthopedic Goods Prosthetic Devices" },
  { code: 5977, description: "Cosmetic Stores" },
  { code: 5978, description: "Typewriter Stores – Sales, Rental, Service" },
  { code: 5983, description: "Fuel – Fuel Oil, Wood, Coal, Liquefied Petroleum" },
  { code: 5992, description: "Florists" },
  { code: 5993, description: "Cigar Stores and Stands" },
  { code: 5994, description: "News Dealers and Newsstands" },
  { code: 5995, description: "Pet Shops, Pet Foods, and Supplies Stores" },
  { code: 5996, description: "Swimming Pools – Sales, Service, and Supplies" },
  { code: 5997, description: "Electric Razor Stores – Sales and Service" },
  { code: 5998, description: "Tent and Awning Shops" },
  { code: 5999, description: "Miscellaneous and Specialty Retail Stores" },
  { code: 6010, description: "Financial Institutions – Manual Cash Disbursements" },
  { code: 6011, description: "Financial Institutions – Manual Cash Disbursements" },
  { code: 6012, description: "Financial Institutions – Merchandise and Services" },
  { code: 6051, description: "Non-Financial Institutions – Foreign Currency, Money Orders (not wire transfer) and Travelers Cheques" },
  { code: 6211, description: "Security Brokers/Dealers" },
  { code: 6300, description: "Insurance Sales, Underwriting, and Premiums" },
  { code: 6381, description: "Insurance Premiums, (no longer valid for first presentment work)" },
  { code: 6399, description: "Insurance, Not Elsewhere Classified ( no longer valid forfirst presentment work)" },
  { code: 6513, description: "Real Estate Agents and Managers - Rentals" },
  { code: 7011, description: "Lodging – Hotels, Motels, Resorts, Central Reservation Services (not elsewhere classified)" },
  { code: 7012, description: "Timeshares" },
  { code: 7032, description: "Sporting and Recreational Camps" },
  { code: 7033, description: "Trailer Parks and Camp Grounds" },
  { code: 7210, description: "Laundry, Cleaning, and Garment Services" },
  { code: 7211, description: "Laundry – Family and Commercial" },
  { code: 7216, description: "Dry Cleaners" },
  { code: 7217, description: "Carpet and Upholstery Cleaning" },
  { code: 7221, description: "Photographic Studios" },
  { code: 7230, description: "Barber and Beauty Shops" },
  { code: 7251, description: "Shop Repair Shops and Shoe Shine Parlors, and Hat Cleaning Shops" },
  { code: 7261, description: "Funeral Service and Crematories" },
  { code: 7273, description: "Dating and Escort Services" },
  { code: 7276, description: "Tax Preparation Service" },
  { code: 7277, description: "Counseling Service – Debt, Marriage, Personal" },
  { code: 7278, description: "Buying/Shopping Services, Clubs" },
  { code: 7296, description: "Clothing Rental – Costumes, Formal Wear, Uniforms" },
  { code: 7297, description: "Massage Parlors" },
  { code: 7298, description: "Health and Beauty Shops" },
  { code: 7299, description: "Miscellaneous Personal Services ( not elsewhere classifies)" },
  { code: 7311, description: "Advertising Services" },
  { code: 7321, description: "Consumer Credit Reporting Agencies" },
  { code: 7332, description: "Blueprinting and Photocopying Services" },
  { code: 7333, description: "Commercial Photography, Art and Graphics" },
  { code: 7338, description: "Quick Copy, Reproduction and Blueprinting Services" },
  { code: 7339, description: "Stenographic and Secretarial Support Services" },
  { code: 7342, description: "Exterminating and Disinfecting Services" },
  { code: 7349, description: "Cleaning and Maintenance, Janitorial Services" },
  { code: 7361, description: "Employment Agencies, Temporary Help Services" },
  { code: 7372, description: "Computer Programming, Integrated Systems Design and Data Processing Services" },
  { code: 7375, description: "Information Retrieval Services" },
  { code: 7379, description: "Computer Maintenance and Repair Services, Not Elsewhere Classified" },
  { code: 7392, description: "Management, Consulting, and Public Relations Services" },
  { code: 7393, description: "Protective and Security Services – Including Armored Carsand Guard Dogs" },
  { code: 7394, description: "Equipment Rental and Leasing Services, Tool Rental, Furniture Rental, and Appliance Rental" },
  { code: 7395, description: "Photofinishing Laboratories, Photo Developing" },
  { code: 7399, description: "Business Services, Not Elsewhere Classified" },
  { code: 7511, description: "Truck Stop" },
  { code: 7512, description: "Car Rental Companies ( Not Listed Below)" },
  { code: 7513, description: "Truck and Utility Trailer Rentals" },
  { code: 7519, description: "Motor Home and Recreational Vehicle Rentals" },
  { code: 7523, description: "Automobile Parking Lots and Garages" },
  { code: 7531, description: "Automotive Body Repair Shops" },
  { code: 7534, description: "Tire Re-treading and Repair Shops" },
  { code: 7535, description: "Paint Shops – Automotive" },
  { code: 7538, description: "Automotive Service Shops" },
  { code: 7542, description: "Car Washes" },
  { code: 7549, description: "Towing Services" },
  { code: 7622, description: "Radio Repair Shops" },
  { code: 7623, description: "Air Conditioning and Refrigeration Repair Shops" },
  { code: 7629, description: "Electrical And Small Appliance Repair Shops" },
  { code: 7631, description: "Watch, Clock, and Jewelry Repair" },
  { code: 7641, description: "Furniture, Furniture Repair, and Furniture Refinishing" },
  { code: 7692, description: "Welding Repair" },
  { code: 7699, description: "Repair Shops and Related Services –Miscellaneous" },
  { code: 7800, description: "Government-Owned Lotteries" },
  { code: 7801, description: "Government-Licensed On-Line Casinos (On-Line Gambling)" },
  { code: 7802, description: "Government-Licensed Horse/Dog Racing" },
  { code: 7829, description: "Motion Pictures and Video Tape Production and Distribution" },
  { code: 7832, description: "Motion Picture Theaters" },
  { code: 7841, description: "Video Tape Rental Stores" },
  { code: 7911, description: "Dance Halls, Studios and Schools" },
  { code: 7922, description: "Theatrical Producers (Except Motion Pictures), Ticket Agencies" },
  { code: 7929, description: "Bands, Orchestras, and Miscellaneous Entertainers (Not Elsewhere Classified)" },
  { code: 7932, description: "Billiard and Pool Establishments" },
  { code: 7933, description: "Bowling Alleys" },
  { code: 7941, description: "Commercial Sports, Athletic Fields, Professional Sport Clubs, and Sport Promoters" },
  { code: 7991, description: "Tourist Attractions and Exhibits" },
  { code: 7992, description: "Golf Courses – Public" },
  { code: 7993, description: "Video Amusement Game Supplies" },
  { code: 7994, description: "Video Game Arcades/Establishments" },
  { code: 7995, description: "Betting (including Lottery Tickets, Casino Gaming Chips, Off-track Betting and Wagers at Race Tracks)" },
  { code: 7996, description: "Amusement Parks, Carnivals, Circuses, Fortune Tellers" },
  { code: 7997, description: "Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses" },
  { code: 7998, description: "Aquariums, Sea-aquariums, Dolphinariums" },
  { code: 7999, description: "Recreation Services (Not Elsewhere Classified)" },
  { code: 8011, description: "Doctors and Physicians (Not Elsewhere Classified)" },
  { code: 8021, description: "Dentists and Orthodontists" },
  { code: 8031, description: "Osteopaths" },
  { code: 8041, description: "Chiropractors" },
  { code: 8042, description: "Optometrists and Ophthalmologists" },
  { code: 8043, description: "Opticians, Opticians Goods and Eyeglasses" },
  { code: 8044, description: "Opticians, Optical Goods, and Eyeglasses (no longer validfor first presentments)" },
  { code: 8049, description: "Podiatrists and Chiropodists" },
  { code: 8050, description: "Nursing and Personal Care Facilities" },
  { code: 8062, description: "Hospitals" },
  { code: 8071, description: "Medical and Dental Laboratories" },
  { code: 8099, description: "Medical Services and Health Practitioners (Not Elsewhere Classified)" },
  { code: 8111, description: "Legal Services and Attorneys" },
  { code: 8211, description: "Elementary and Secondary Schools" },
  { code: 8220, description: "Colleges, Junior Colleges, Universities, and ProfessionalSchools" },
  { code: 8241, description: "Correspondence Schools" },
  { code: 8244, description: "Business and Secretarial Schools" },
  { code: 8249, description: "Vocational Schools and Trade Schools" },
  { code: 8299, description: "Schools and Educational Services ( Not Elsewhere Classified)" },
  { code: 8351, description: "Child Care Services" },
  { code: 8398, description: "Charitable and Social Service Organizations" },
  { code: 8641, description: "Civic, Fraternal, and Social Associations" },
  { code: 8651, description: "Political Organizations" },
  { code: 8661, description: "Religious Organizations" },
  { code: 8675, description: "Automobile Associations" },
  { code: 8699, description: "Membership Organizations ( Not Elsewhere Classified)" },
  { code: 8734, description: "Testing Laboratories ( non-medical)" },
  { code: 8911, description: "Architectural – Engineering and Surveying Services" },
  { code: 8931, description: "Accounting, Auditing, and Bookkeeping Services" },
  { code: 8999, description: "Professional Services ( Not Elsewhere Defined)" },
  { code: 9211, description: "Court Costs, including Alimony and Child Support" },
  { code: 9222, description: "Fines" },
  { code: 9223, description: "Bail and Bond Payments" },
  { code: 9311, description: "Tax Payments" },
  { code: 9399, description: "Government Services ( Not Elsewhere Classified)" },
  { code: 9402, description: "Postal Services – Government Only" },
  { code: 9405, description: "Intra – Government Transactions" },
  { code: 9700, description: "Automated Referral Service ( For Visa Only)" },
  { code: 9701, description: "Visa Credential Service ( For Visa Only)" },
  { code: 9702, description: "GCAS Emergency Services ( For Visa Only)" },
  { code: 9950, description: "Intra – Company Purchases ( For Visa Only)" },
];

/** Zero-pad a numeric MCC to its canonical 4-digit form (742 -> "0742"). */
const pad4 = (n: number): string => String(n).padStart(4, "0");

export const mccOptions: DropdownOption<number>[] = MCC_CODES.map((m) => ({
  value: m.code,
  label: m.description,
  code: pad4(m.code),
}));
